<template>
    <div class="simple-print-table">
        <div class="chart">
            <v-chart ref="pieChart" :option="chartOption" style="width: 250px; height: 250px" />
        </div>
        <div class="table">
            <table cellspacing="0" cellpadding="0">
                <tbody>
                    <template v-for="(item, i) in tableData">
                        <tr :key="i" class="group-row">
                            <td class="left">
                                <span v-if="item.custom">（自編）</span>
                                {{ item.name }}
                            </td>
                            <td class="right">
                                <money :v="item.value" round />
                            </td>
                            <td class="right">{{ getPercentage(item.value, total) }} %</td>
                        </tr>
                    </template>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="left">總計</td>
                        <td class="right">
                            <money :v="total" round />
                        </td>
                        <td class="right">100 %</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';

import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: { VChart },
    props: {
        chartOption: {
            type: Object,
            default: () => {},
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        getPercentage: {
            type: Function,
            default: () => {},
        },
        total: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-print-table {
    @media screen {
        display: none;
    }
    display: flex;
    .table {
        flex: 1;
    }
    table {
        margin-top: 40px;
        width: 100%;
        line-height: 130%;
        font-size: 10pt;

        td {
            padding: 0;
            .money {
                font-weight: normal;
            }
        }

        th.left,
        td.left {
            text-align: left;
        }

        th.right,
        td.right {
            text-align: right;
        }

        tr.group-row td {
            border-top: 1px solid #000;
        }

        tfoot td {
            border-top: 2px solid #333;
            padding-top: 5px;
            vertical-align: top;
        }
    }
}
</style>
